/**
  * @ngdoc directive
  * @name cms.directive:richText
  * @restrict 'E'
  * @param {json} data the json generated from draftjs.
  * @description
  * Element directive  used to generate the wyswyg content from the new CMS
  * El json que se ha de introducir ha de tener un formato similar a :
  * 
  * @example
  * ## En el controller padre
  * <pre>
  *  _this.jsonTexttext= { "blocks": [
                {
                  "key": "5ne4b",
                  "text": "DEmo texto 1 ",
                  "type": "unstyled",
                  "depth": 0,
                  "inlineStyleRanges": [],
                  "entityRanges": [],
                  "data": {}
                },
                ...
            ],
            "entityMap": {
                "0": {
                  "type": "LINK",
                  "mutability": "MUTABLE",
                  "data": {
                    "type": "externalLink",
                    "src": "https://www.massimodutti.com/es/",
                    "hasNavigation": true
                }
            }
        };
    </pre>
 *  ## En el html
 *   ```
 *     <rich-content data="$ctrl.jsonText"></rich-content>
 *   ```
 * 
**/
(function() {

    'use strict';

    var richText = {
        restrict: 'E',
        scope: {
            data: '<',
            ignoreLink: '<',
            sref:'<'
        },
        link:link        
    };

    link.$inject = ['scope', 'element'];

    function link(scope, element) {

        var stringStore = '%STORE%';
        var stringLang = '%LANG%';
        var stringTimestamp = '%TIMESTAMP%';
        var inputData = scope.data;
        // angular.forEach(scope.data.entityMap, function(link){
        //     link.data.src = link.data.src.replace('}}','');
        //     link.data.src = link.data.src.replace('{{','');
        // })
        // var lucas = JSON.stringify(inputData).replace('{{','');
        // lucas = lucas.replace('}}','');
        // lucas = JSON.parse(JSON.stringify(lucas));
        element.append(draftjsToHtml(scope.data, null, null, function(elem,text){
            var href,a;
            
            if(scope.ignoreLink){
                return '';
            }

            if(elem.data.url){
                href = generateHref(elem.data.url);
                if(elem.data.newWindow){
                    a = '<a ' + href + ' target="_blank">'+ text +'</a>';
                } else {
                    a = '<a '+ href +'>'+ text +'</a>';
                }
                return a;
            }
            if(elem.data.src){
                href = generateHref(elem.data.src);
                if(elem.data.hasNavigation){
                    a = '<a ' + href + ' target="_blank">'+ text +'</a>';
                } else {
                    a = '<a '+ href +'>'+ text +'</a>';
                }
                return a;
            }

            
        }));

        function generateHref(url) {
            var isDinamicStore = url.indexOf(stringStore) > -1;
            var isDinamicLang = url.indexOf(stringLang) > -1;
            var isDinamicTimestamp = url.indexOf(stringTimestamp) > -1;
            if(isDinamicStore){
                url = url.replace(stringStore, inditex.iStoreId);                
            }
            if(isDinamicLang){
                url = url.replace(stringLang, inditex.iLangId);                
            }
            if(isDinamicTimestamp){
                url = url.replace(stringTimestamp, new Date().getTime() );                
            }
            return 'href="' + url + '"';
        }

    }
    
    angular.module('itxApp.help')
        .directive('richText', function() {return richText;});

})();